module.exports = __webpack_public_path__ + "img/益视说明书_06.e7ddbe31.png";